import axios from "./axios";
import config from "./config";
import carriers from "./carriers";
const common = {
    getDictList(dictCode) {
        return axios.get(`/dictionary/select/${dictCode}`);
    },
    // 查询火车站站点
    getRailwayStations(params) {
        return axios.get(`/railway/like`,{
            params:{
                data:params.keyword,
                current:params.currentPage,
                size:params.pageSize,
            }
        });
    },
    // 查询专用线
    getRailwaySpecial(params) {
        return axios.get(`/railway/special`,{
            params:{
                station:params.keyword,
                current:params.currentPage,
                size:params.pageSize,
            }
        });
    },
    // 查询字典
    getDictObjectArray(params){
        return axios.get(`/net-work-freight-map/dict/select/${params}`,);
    },
    // 获取仓库列表
    getWarehouseList(params){
        return axios.get(`/net-work-freight-map/warehouse/list`,{
            params:{
                ...params
            }
        });
    },
    // 查询货权方
    getGoodsMerchantList(params){
        return axios.get(`/net-work-freight-map/getGoodsMerchant/list`,{
            params:{
                ...params
            }
        });
    }
}
export default common;